import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TrophyIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M16.2 6.2998L16.2 4.7998H7.8001V10.7794L7.80005 10.7999C7.80005 10.9007 7.8036 11.0007 7.81059 11.0998H7.8C7.13333 11.0998 6.80352 10.8422 6.61038 10.5739C6.3842 10.2598 6.3 9.85578 6.3 9.5998V8.0998H7.8V6.2998H4.5V9.5998C4.5 10.1438 4.6558 10.9398 5.14962 11.6257C5.67648 12.3574 6.54667 12.8998 7.8 12.8998H8.36191C8.9438 13.9057 9.93094 14.6479 11.1001 14.9032V17.7H9V19.5H15V17.7H12.9001V14.9031C14.0692 14.6479 15.0563 13.9057 15.6381 12.8998H16.2C17.4533 12.8998 18.3235 12.3574 18.8504 11.6257C19.3442 10.9398 19.5 10.1438 19.5 9.5998V6.2998H16.2ZM16.2 8.0998L16.2 10.7999C16.2 10.9007 16.1964 11.0007 16.1895 11.0998H16.2C16.8667 11.0998 17.1965 10.8422 17.3896 10.5739C17.6158 10.2598 17.7 9.85578 17.7 9.5998V8.0998H16.2ZM9.60009 6.59977V10.788L9.60004 10.7999C9.60004 12.1253 10.6745 13.1998 12 13.1998C13.3255 13.1998 14.4 12.1253 14.4 10.7999V8.99972L14.4001 6.59977H9.60009Z"
      />
    </SvgIcon>
  );
});
